<template>
  <gj-modal
      size="1200_auto"
      v-bind="$attrs"
      v-on="$listeners"
      :visible.sync="modalVisible"
  >
    <template #header>
      <div>
        跟卖详情
      </div>
    </template>
    <template #content>
      <div style="font-size: 12px" v-loading="reloadLoading">
        <div class="detail-title mb-top20">
          <el-row class="gj-mb10">
            <el-col :span="2">
              <gj-image
                  :src="rowItem.imageUrl"
                  :size="80"
                  tag-color="rgb(246 144 10)">
              </gj-image>
            </el-col>
            <el-col :span="22">
              <el-row class="gj-mb10">
                <div class="text-ellipsis-2" style="width: 90%;display: -webkit-box;color: #333;">{{rowItem.listingTitle}}</div>
              </el-row>
              <el-row class="gj-mb10">
                <el-col :span="8">
                  <span class="detail-label" style="width: 55px;text-align: left">店铺/国家</span>
                  <span class="detail-value">{{ rowItem.marketId | optionText(marketOption) | defaultShow }}</span>
                </el-col>
                <el-col :span="8">
                  <span class="detail-label" style="width: 30px;text-align: left">ASIN</span>
                  <span class="detail-value">{{rowItem.asin}}</span>
                </el-col>
                <el-col :span="8">
                  <span class="detail-label" style="width: 42px;text-align: left">父ASIN</span>
                  <span class="detail-value">{{rowItem.variationAsin}}</span>
                </el-col>
              </el-row>
            </el-col>
          </el-row>
        </div>
        <gj-table
            :data="data"
            :columns="columns"
            :show-pagination="false"
            :adapt-height="false"
            :height="500"
            :isMinHeight="false"
            class="detail-table-remove-hover"
        >
          <template v-slot:offerSellerId="{ row }">
            {{row.offerSellerId}}
          </template>
          <template v-slot:listingPrice="{ row }">
            {{row.listingPriceCurrencySymbol + row.listingPrice}}
          </template>
          <template v-slot:buyBoxWinner="{ row }">
            {{row.buyBoxWinner ? "是" : "否"}}
          </template>
          <template v-slot:fulfillmentChannel="{ row }">
            {{row.fulfillmentChannel}}
          </template>
          <template v-slot:fulfilledByAmazon="{ row }">
            {{row.fulfilledByAmazon ? "亚马逊自营" : "普通卖家"}}
          </template>
          <template v-slot:followerInfo="{ row }">
            <gj-tooltip :content="row.positiveFeedbackRating + '% positive over the past 12 months.(' + row.feedbackCount + 'total ratings)'" :text-line="2">
              {{row.positiveFeedbackRating + "% positive over the past 12 months.(" + row.feedbackCount +"total ratings)"}}
            </gj-tooltip>
          </template>
          <template v-slot:offerStartTime="{ row }">
            {{row.offerStartTime}}
          </template>
          <template v-slot:offerEndTime="{ row }">
            {{row.offerEndTime}}
          </template>
        </gj-table>
      </div>
    </template>
    <template #footer>
      <gj-button @click.stop="cancel">关闭</gj-button>
    </template>
  </gj-modal>
</template>

<script>
  import {modalMixIn, responseMixin} from "@/minxins";
  import {isMeaningful, } from "@/utils/common";
  import {currencysOption, saleOrderStatus} from "@/utils/options";
  import {mapGetters} from "vuex";
  import {getFollowDetail} from "@/api/tool";

  export default {
    mixins: [modalMixIn, responseMixin],
    name: "follow-up-detail",
    computed: {
      ...mapGetters({
        marketMap: 'marketMap',
        marketOption: 'marketOption'
      })
    },
    props: {
      rowItem:{
        type: Object,
      },
      fid: {
        type: String
      },
      marketId: {
        required: true,
        type: String,
      },
      showBtn: {
        type: Boolean,
        default: false,
      },
    },
    created() {
      this.getFollowDetail();
    },
    data() {
      return {
        data: [],
        columns: [
          {id: 'offerSellerId', header: '跟卖者', field: 'slot:offerSellerId', minWidth: '100px', maxWidth: '100px', default: true},
          {id: 'listingPrice', header: '跟卖价格', field: 'slot:listingPrice', minWidth: '100px', maxWidth: '100px', default: true},
          {id: 'buyBoxWinner', header: '是否占领黄金购物区', field: 'slot:buyBoxWinner', minWidth: '100px', maxWidth: '100px', default: true},
          // {id: 'fulfillmentChannel', header: '跟卖类型', field: 'slot:fulfillmentChannel', minWidth: '100px', maxWidth: '100px', default: true},
          {id: 'fulfilledByAmazon', header: '配送渠道', field: 'slot:fulfilledByAmazon', minWidth: '100px', maxWidth: '100px', default: true},
          {id: 'followerInfo', header: '跟卖者信息', field: 'slot:followerInfo', minWidth: '100px', maxWidth: '100px', default: true},
          {id: 'offerStartTime', header: '跟卖开始时间', field: 'slot:offerStartTime', minWidth: '100px', maxWidth: '100px', default: true},
          {id: 'offerEndTime', header: '跟卖结束时间', field: 'slot:offerEndTime', minWidth: '100px', maxWidth: '100px', default: true},
        ],
        saleOrderStatus: saleOrderStatus,
        currencyOption: currencysOption.map(v => ({id: v.id, text: v.id})),
        loading: false,
        reloadLoading: false,
      }
    },
    methods: {
      getFollowDetail() {
        this.reloadLoading = true;
        getFollowDetail({model:{fid: this.fid}})
          .then((data) => {
            this.data = data.records ||[];
            // this.data.marketName = this.marketMap[data.marketId] && this.marketMap[data.marketId].text;
          }).complete(() => this.reloadLoading = false)
      },
    }
  }
</script>

<style scoped>
  .mb-top20 {
    margin-top: 20px;
  }

  .detail-title {
    margin-bottom: 12px;
  }

  .detail-label {
    margin-right: 12px;
    display: inline-block;
    width: 18%;
    text-align: right;
    color: #666;
  }

  .detail-value {
    color: #333;
  }

  .detail-table-label {
    color: #666;
  }

  .detail-memo-color {
    color: #bbb;
    font-size: 12px;
  }

  .detail-table-background {
    background: #f5f7fa;
  }

  .detail-subtotal {
    font-weight: 700;
    color: #333;
  }

  .detail-table-remove-hover {
  }

  .detail-table-remove-hover /deep/ .el-table--enable-row-hover .el-table__body tr:hover > td {
    background: white;
  }

  .inner-row .el-row:not(:last-child) {
    margin-bottom: 8px;
  }

  /deep/ tr:hover > td {
    background: #fff;
  }
  /deep/ .el-dialog__body{
    padding-bottom: 0;
  }
</style>
